import React from "react";
import AyudaTablaRegistros from "./AyudaTablaRegistros";

const HelperDataTableExpandible = (props) => {
  return <AyudaTablaRegistros expandible={true} {...props} />;
};

export default HelperDataTableExpandible;
